import { SITE_TAG_BOOST } from './constants'

export const generateSponsorTierOptionalFilters = ({
  sponsorBoost
}: {
  sponsorBoost: number
}): string[][] => {
  return [
    [
      `sponsor_tier:1<score=${sponsorBoost}>`,
      `sponsor_tier:2<score=${sponsorBoost}>`,
      `sponsor_tier:3<score=${sponsorBoost}>`
    ],
    [`site:lux<score=${SITE_TAG_BOOST}>`, `site:samhsa<score=0>`]
  ]
}
